import { Checkbox } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

export const InstyleCheckbox = withStyles({
  root: {
    color: "var(--color-yellow)",
    '&$checked': {
      color: "var(--color-yellow)",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
